import { Link } from "react-router-dom";
import PublicLayout from "../layout/Public";

function Error(props) {
  const { title, message } = props;

  return (
    <PublicLayout title={title}>
      <div className="text-center pb-4">
        <h1 className="text-4xl font-bold">{title}</h1>
        <div className="text-center pt-4">{message}</div>
      </div>
      <div className="text-center pt-6">
        <Link to="/login" className="text-secondary">
          Back to login
        </Link>
      </div>
    </PublicLayout>
  );
}

export default Error;
